$bog_ainews_app_feed_img $mol_view
	src? null
	alt? null
	width? null
	height? null
